import * as svg from "../../../assets/eye-solid-icon.svg";

import {iconBuilder} from "./iconBuilder";

export const EyeSolidIcon = iconBuilder(svg, "EyeSolidIcon", "0 0 16 16");
